export var DEFAULT_CACHE_VERIFICATION_OPTIONS = {
  shouldRevalidate: false
};
//# sourceMappingURL=consts.js.map